export const legacySyncQueryRootKey = ["legacy_sync", "targets"] as const;
